import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withKeys as _withKeys, withModifiers as _withModifiers, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/trash.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-17fca6e5")

_pushScopeId("data-v-17fca6e5")
const _hoisted_1 = { class: "upload-document" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pt-4 justify-center gap-x-2" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-4.5 max-w-none",
  alt: "exclamation triangle red"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_card = _resolveComponent("card")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_card, {
      customClass: "border-0",
      isShadow: false
    }, {
      default: _withId(() => [
        (_ctx.modelValue || _ctx.defaultImage)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: `upload-document__preview ${_ctx.widthContentCard}`,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPreview && _ctx.onPreview(...args))),
              tabindex: _ctx.disabled ? '-1' : '0',
              role: "button",
              onKeydown: [
                _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onPreview && _ctx.onPreview(...args)), ["enter"])),
                _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.onPreview && _ctx.onPreview(...args)), ["prevent"]), ["space"]))
              ]
            }, [
              (_ctx.isTypePdf || _ctx.typeFileDefaultIsPdf)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    src: require(`@/app/ui/assets/images/default-pdf.jpeg`),
                    class: "upload-document__image",
                    alt: "result-image"
                  }, null, 8, ["src"]))
                : (_openBlock(), _createBlock("img", {
                    key: 1,
                    src: _ctx.fileOriginal || _ctx.defaultImage,
                    class: `upload-document__image ${_ctx.widthImage}`,
                    alt: "result-image"
                  }, null, 10, ["src"])),
              (!_ctx.disabled)
                ? (_openBlock(), _createBlock("button", {
                    key: 2,
                    type: "button",
                    class: "upload-document__remove",
                    "aria-label": "Remove document",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setDefault && _ctx.setDefault(...args)))
                  }, [
                    _hoisted_2
                  ]))
                : _createCommentVNode("", true)
            ], 42, ["tabindex"]))
          : (_openBlock(), _createBlock("div", {
              key: 1,
              tabindex: _ctx.disabled ? '-1' : '0',
              role: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.disabled ? null : _ctx.$refs.file.click())),
              onKeydown: [
                _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.disabled ? null : _ctx.$refs.file.click()), ["enter"])),
                _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (_ctx.disabled ? null : _ctx.$refs.file.click()), ["prevent"]), ["space"]))
              ],
              onDragover: _cache[8] || (_cache[8] = (e) => _ctx.setDragAndDrop(e, true)),
              onDragleave: _cache[9] || (_cache[9] = (e) => _ctx.setDragAndDrop(e, false)),
              onDrop: _cache[10] || (_cache[10] = (e) => _ctx.onSubmitDrag(e)),
              class: 
          `upload-document__empty ${
            _ctx.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
          } ${
            _ctx.isDragFile
              ? 'border-gray-lp-600 bg-gray-lp-100'
              : _ctx.hasError
              ? 'border-red-lp-1000'
              : 'border-gray-lp-400'
          }`
        
            }, [
              _createVNode(_component_Icons, {
                class: !_ctx.hasError ? 'text-gray-lp-600' : 'text-red-lp-1000',
                name: "grey-plus"
              }, null, 8, ["class"])
            ], 42, ["tabindex"])),
        _createVNode("input", {
          id: String(_ctx.$attrs.id),
          type: "file",
          ref: "file",
          onChange: _cache[11] || (_cache[11] = (e) => (_ctx.isDragFile ? _ctx.onSubmitDrag(e) : _ctx.onSubmitClick(e))),
          accept: _ctx.accept,
          class: "hidden"
        }, null, 40, ["id", "accept"]),
        _withDirectives(_createVNode("div", {
          class: `upload-document__title text-${_ctx.titleSize}px`
        }, null, 2), [
          [_directive_sanitize_html, 
          `${_ctx.title}<br />${
            _ctx.optional
              ? `
            <div
              class='text-center text-sm text-gray-lp-500'
              :class='text-${_ctx.titleSize}px'
            >
              (${_ctx.$t('optional')})
            </div>`
              : ''
          }`
        ]
        ]),
        _withDirectives(_createVNode("p", _hoisted_3, [
          _hoisted_4,
          _createVNode("span", null, _toDisplayString(_ctx.errorCaption || `Maks. ${_ctx.maxSize}MB`), 1)
        ], 512), [
          [_vShow, _ctx.hasError && _ctx.showErrorMessage]
        ])
      ]),
      _: 1
    })
  ]))
})